import classNames from 'classnames';
import { SearchBar } from '@/components/organisms/search-bar/search-bar';
import Column from '@/components/utilities/column/column';
import Container from '@/components/utilities/container/container';
import Row from '@/components/utilities/row/row';
import parseDanishDate from '@/libraries/formatters/parse-danish-date';
import styles from './search-page-header.module.scss';

export interface SearchPageHeaderProps {
  /** Search settings for filters and search bar */
  searchSettings: Content.Components['SearchSettingsDto'];
}

const SearchPageHeader = ({ searchSettings }: SearchPageHeaderProps) => {
  if (!searchSettings) {
    return null;
  }

  const propDefaultValues =
    searchSettings.$type === 'SearchSettingsDto'
      ? {
          adultsNumber:
            searchSettings.selectedPaxDistribution?.adultsNo.toString(),
          departureDate: searchSettings.selectedDepartureDate
            ? parseDanishDate(searchSettings.selectedDepartureDate.toString())
            : undefined,
          departureId: searchSettings.selectedDepartureId?.toString(),
          destinationIds: searchSettings.selectedDestinationIds?.map(id =>
            id.toString(),
          ),
          destinationRegionIds:
            searchSettings.selectedDestinationRegionIds?.map(id =>
              id.toString(),
            ),
          durationType: searchSettings.selectedPeriodType,
        }
      : undefined;

  return (
    <section className={classNames(styles.component)}>
      <Container>
        <Row className={styles.row}>
          <Column width={{ desktop: 12 }}>
            <div className={styles.searchBarContainer}>
              <SearchBar
                autoSearch
                className={styles.searchBar}
                compact
                propDefaultValues={propDefaultValues}
                searchSettings={searchSettings}
                shouldNavigate
              />
            </div>
          </Column>
        </Row>
      </Container>
    </section>
  );
};

SearchPageHeader.displayName = 'SearchPageHeader';

export default SearchPageHeader;
